import React from 'react';

import { Menu, MenuItem } from '@material-ui/core';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import { selectOrgData } from 'selectors/orgData';
import styled from 'styled-components';

import { KeyResultIcon, ObjectiveIcon } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const OKRMenuOptions = ({ addObjective = () => {}, addKR = () => {}, isOpen = false, anchorEl }) => {
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData);

  const { objectiveCreationAccess } = useSelector(selectOrgData);

  // const showObjectiveOption = checkUserIsGoalAdmin() || loggedInEmployee?.isHRISManager;

  const showObjectiveOption = () => true;

  const handleClose = (e, option) => {
    switch (option) {
      case 'ADD_OBJECTIVE':
        addObjective();
        break;
      case 'ADD_KR':
        addKR();
        break;
      default:
        break;
    }
  };

  /*  read keyResultsName and objectivesName from new config */
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  return (
    <StyledMenu
      anchorEl={anchorEl?.current}
      keepMounted
      open={isOpen}
      onClose={handleClose}
      disablePortal
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {showObjectiveOption() && (
        <StyledMenuItem onClick={(e) => handleClose(e, 'ADD_OBJECTIVE')}>
          <ObjectiveIcon boxSize="20px" />

          <TextBodyMedium ml={2} color="inherit">
            New {objectivesName}
          </TextBodyMedium>
        </StyledMenuItem>
      )}
      <StyledMenuItem onClick={(e) => handleClose(e, 'ADD_KR')}>
        <KeyResultIcon boxSize="20px" />

        <TextBodyMedium ml={2} color="inherit">
          New {keyResultsName}
        </TextBodyMedium>
      </StyledMenuItem>
    </StyledMenu>
  );
};
const StyledMenu = styled(Menu)`
  ul {
    padding: 8px;
  }
`;
const StyledMenuItem = styled(MenuItem)`
  padding: 8px 4px;
  border-radius: 4px;

  &:hover {
    color: #104f95;
    background-color: #e6f1fd;

    svg {
      color: #104f95;
    }
  }
`;
